/**
 * Decode audio blob with AudioContext to get exact duration in milliseconds.
 *
 * Works for any browser-decodable format including WebM/Opus without a
 * duration header — which is what MediaRecorder produces and what causes
 * HTMLAudioElement.duration to remain Infinity until the file is nearly
 * fully buffered.
 *
 * Returns 0 if decoding fails or times out.
 */
export async function decodeDurationMs(blob: Blob): Promise<number> {
  try {
    const arrayBuffer = await blob.arrayBuffer();
    const ctx = new AudioContext();
    try {
      const decode = ctx.decodeAudioData(arrayBuffer);
      const timeout = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error('decode timeout')), 5000)
      );
      const buf = await Promise.race([decode, timeout]);
      return Math.round(buf.duration * 1000);
    } finally {
      ctx.close().catch(() => {});
    }
  } catch {
    return 0;
  }
}
